"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../../BootstrapHelper");
var IconSymbols_1 = require("../../../generated/IconSymbols");
var Icon_1 = require("../../Icon");
var enums_1 = require("../../../enums");
var ToggleSwitch = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("toggle-switch")
        .pmod(props.disabled ? "disabled" : "").bem;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ id: props.id || "", className: "".concat(cls, " ").concat(props.className || "") }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "toggle-switch__holder ".concat(props.isChecked && "toggle-switch__checked") }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "icon tick-symbol", symbol: IconSymbols_1.IconSymbols.Check, size: enums_1.Enums.UiSizes.SM }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "icon close-symbol", symbol: IconSymbols_1.IconSymbols.Close, size: enums_1.Enums.UiSizes.SM })] })), (0, jsx_runtime_1.jsx)("input", { id: props.id, disabled: props.disabled, checked: props.isChecked, onChange: function (e) {
                    props === null || props === void 0 ? void 0 : props.onChange(e);
                }, type: "checkbox", className: "toggle-switch__input" })] })));
};
exports.ToggleSwitch = ToggleSwitch;
